export default function CalendarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19 4H17V2H15V4H9V2H7V4H5C3.9 4 3 4.9 3 6V8V10V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V10V8V6C21 4.9 20.1 4 19 4ZM19 10V20H5V10H19ZM5 8V6H19V8H5Z"
        fill="#544F4F"
      />
    </svg>
  );
}
